/**
 * TaskOverviewSection utilities and constants
 * @module pages/DashboardPage/components/TaskOverviewSection
 */

import {
  IconHourglass,
  IconClock,
  IconCircleCheck,
  IconAlertTriangle,
} from '@tabler/icons-react';

import type { TaskStats } from './TaskOverviewSection.types';

/** Chart series configuration — hex values match Mantine green-6, blue-6, red-5, gray-6 (identical in light/dark) */
export const CHART_SERIES = [
  {
    dataKey: 'pending',
    color: '#868e96',
    labelKey: 'dashboard.taskProgress.legendPending',
  },
  {
    dataKey: 'inProgress',
    color: '#228be6',
    labelKey: 'dashboard.taskProgress.legendInProgress',
  },
  {
    dataKey: 'delayed',
    color: '#fa5252',
    labelKey: 'dashboard.taskProgress.legendDelayed',
  },
  {
    dataKey: 'completed',
    color: '#40c057',
    labelKey: 'dashboard.taskProgress.legendCompleted',
  },
] as const;

/** Icon size inside the KPI icon box (px) */
export const KPI_ICON_SIZE = 16;

/** Configuration for each KPI card in the summary row */
export const KPI_CONFIG = [
  {
    key: 'pending' as const,
    labelKey: 'dashboard.taskSummary.pending',
    Icon: IconHourglass,
    color: 'gray',
  },
  {
    key: 'inProgress' as const,
    labelKey: 'dashboard.taskSummary.inProgress',
    Icon: IconClock,
    color: 'blue',
  },
  {
    key: 'completed' as const,
    labelKey: 'dashboard.taskSummary.completed',
    Icon: IconCircleCheck,
    color: 'green',
  },
  {
    key: 'delayed' as const,
    labelKey: 'dashboard.taskSummary.delayed',
    Icon: IconAlertTriangle,
    color: 'red',
  },
] as const;

/** Default empty stats used when API data hasn't loaded yet */
export const EMPTY_STATS: TaskStats = {
  total: 0,
  pending: 0,
  inProgress: 0,
  completed: 0,
  delayed: 0,
};
